module.exports = __webpack_public_path__ + "static/HuntingWhyus-53793fb5cd67014bb30dce128ed5d3fe.png";